import { NgClass, NgIf } from '@angular/common';
import { Component, inject, Inject, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FuseConfirmationConfig } from '@fuse/services/confirmation/confirmation.types';
import { CatalogueService } from 'app/_services/catalogue.service';
import { FormsService } from 'app/_services/forms.service';

@Component({
  selector: 'fuse-confirmation-dialog',
  templateUrl: './dialog.component.html',
  styles: [
    `
      .fuse-confirmation-dialog-panel {
        @screen md {
          @apply w-128;
        }

        .mat-mdc-dialog-container {
          .mat-mdc-dialog-surface {
            padding: 0 !important;
          }
        }
      }
    `,
  ],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [NgIf, MatButtonModule, MatDialogModule, MatIconModule, NgClass, MatProgressSpinnerModule],
})
export class FuseConfirmationDialogComponent {
  private _catalogueService = inject(CatalogueService);
  private _formService = inject(FormsService);
  private _snackBar = inject(MatSnackBar);
  private _dialogRef = inject(MatDialogRef<FuseConfirmationDialogComponent>);
  purge = false;
  /**
   * Constructor
   */
  constructor(@Inject(MAT_DIALOG_DATA) public data: FuseConfirmationConfig) {}
  confirm() {
    this.purge = true;
    if (this.data.viewName == 'Template Items') {
      this.deleteTemplateRecords(this.data.data);
    } else if (this.data.viewName == 'Templates') {
      this.deleteTemplateDefinition(this.data.data);
    }
    if (this.data.catlogueInfo) {
      this.purgeCatalogue();
    }
    if (this.data.viewName == 'user' || this.data.viewName == "questionbuilder") {
      this._dialogRef.close('confirmed');
    }
  }
  async purgeCatalogue() {
    try {
      await this._catalogueService.purgeCatalogueItem(this.data.catlogueInfo.catalogueUserFormId, this.data.catlogueInfo.catalogueItemValue, this.data.catlogueInfo.itemId);
      this.purge = false;
      this._dialogRef.close('confirmed');
    } catch (ex) {
      this._snackBar.open('Something went wrong while processing your request', '', {
        duration: 3000,
        horizontalPosition: 'right',
        verticalPosition: 'top',
        panelClass: ['danger-snackbar'],
      });
      this.purge = false;
      this._dialogRef.close('error');
    }
  }
  async deleteTemplateRecords(data: any) {
    await this._formService
      .deleteTemplateRecordItem(+data.userformId, data.RecordTemplateId)
      .then((res) => {
        if (res) {
          this._formService.templateRecordDeleted.set(true);
          this._dialogRef.close();
        }
      })
      .catch((error) => {
        this._snackBar.open('Something went wrong while processing your request', 'close', {
          duration: 3000,
          horizontalPosition: 'right',
          verticalPosition: 'top',
          panelClass: ['errorSnack'],
        });
        this._dialogRef.close('error');
      });
  }
  async deleteTemplateDefinition(data: any) {
    await this._formService
      .deleteRecordTemplate(+data.UserFormId, data.UserFormRecordTemplateDefinitionId)
      .then((res) => {
        if (res) {
          this._formService.templateDefinitionDeleted.set(true);

          this._dialogRef.close();
        }
      })
      .catch((error) => {
        this._snackBar.open('Something went wrong while processing your request', 'close', {
          duration: 3000,
          horizontalPosition: 'right',
          verticalPosition: 'top',
          panelClass: ['errorSnack'],
        });
        this._dialogRef.close('error');
      });
  }
}
